module.exports = __webpack_public_path__ + "img/kv.b57f24f1.png";